module.exports = __webpack_public_path__ + "img/history.b96bba18.png";